<template>
    <div>
        <transition name="modal">
            <div class="modal-mask" v-show="show">
                <div class="modal-container">
                    <div class="modal-header">
                        <h3>Detalhes da solicitação</h3>
                    </div>
                    <div class="modal-body">
                        <div class="nav-tabs-custom">
                            <ul class="nav nav-tabs">
                                <li class="active">
                                    <a href="#tab_1" data-toggle="tab">Solicitação</a>
                                </li>
                                <li><a href="#tab_2" data-toggle="tab">Boleto</a></li>
                                <li><a href="#tab_3" data-toggle="tab">Histórico</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="tab_1">
                                    <solicitacao-detalhes :solicitacao="$props.solicitacao"></solicitacao-detalhes>
                                </div>
                                <!-- boleto---------------------------------------------------------------------------- -->
                                <div class="tab-pane" id="tab_2">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <router-link :to="'/boleto/' + $props.solicitacao.id" class="btn btn-default btn-sm pull-right" target="_blank"><span class="fa fa-print"></span></router-link>
                                        </div>
                                    </div>
                                    <solicitacao-boleto :solicitacao="$props.solicitacao"></solicitacao-boleto>
                                </div>
                                <!-- boleto---------------------------------------------------------------------------- -->
                                <div class="tab-pane" id="tab_3">
                                    <solicitacao-historico :solicitacao="$props.solicitacao"></solicitacao-historico>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="text-right" style="float:right">
                            <button @click="addInformacao()" v-show="$props.solicitacao.situacao == SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE" class="btn btn-info"><i class="fa fa-comment"></i> Adicionar informação</button>
                            <button @click="confirmarSolicitacao()" v-show="$props.solicitacao.situacao == SITUACAO_SOLICITACAO.REGULADA" class="btn btn-success"><i class="fa fa-check"></i> Confirmar solicitação</button>
                            <button @click="cancelarSolicitacao()" v-show="verificarCancelamento()" class="btn btn-danger"><i class="fa fa-close"></i> Cancelar solicitação</button>
                            <button class="btn btn-default" @click="$emit('close')"><i class="fa fa-close"></i> Fechar</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <modal-confirmar-cancelar @informacaoAdicionada="solicitacao => informacaoAdicionada(solicitacao)" @solicitacaoConfirmada="solicitacao => solicitacaoConfirmada(solicitacao)" @solicitacaoCancelada="solicitacao => solicitacaoCancelada(solicitacao)" :solicitacao="$props.solicitacao" :adicionar-informacao="adicionarInformacao" :confirmar="confirmar" :cancelar="cancelar" :show="showModalConfirmarCancelar" @close="showModalConfirmarCancelar = false"></modal-confirmar-cancelar>
    </div>
</template>

<script>
// import axios from "axios"; // Cliente para requisição http
import solicitacaoDetalhes from "../comuns/solicitacaoDetalhes";
import solicitacaoHistorico from "../comuns/solicitacaoHistorico";
import solicitacaoBoleto from "../comuns/solicitacaoBoleto";
import modalConfirmarCancelar from "./modalConfirmarCancelar";
import moment from "moment";
import { SITUACAO_SOLICITACAO } from "@/constants";
export default {
    props: ["show", "solicitacao"],
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        }
    },
    data: () => ({
        showModalConfirmarCancelar: false,
        cancelar: false,
        confirmar: false,
        adicionarInformacao: false
    }),
    mounted() {},
    methods: {
        verificarCancelamento() {
            switch (this.$props.solicitacao.situacao) {
                case SITUACAO_SOLICITACAO.MARCADA:
                case SITUACAO_SOLICITACAO.CONFIRMADA:
                case SITUACAO_SOLICITACAO.REGULADA:
                    if (this.$store.state.user.nivel != "administrador") {
                        let dataAtendimento = this.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? this.$props.solicitacao.itens[0].contrato_procedimento_atendimento.data_atendimento : this.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.data_atendimento;
                        let horaIncial = this.$props.solicitacao.itens[0].contrato_procedimento_atendimento ? this.$props.solicitacao.itens[0].contrato_procedimento_atendimento.hora_inicial : this.$props.solicitacao.itens[0].contrato_subgrupo_atendimento.hora_inicial;
                        let dataRealizacao = new Date(dataAtendimento + " " + horaIncial);
                        if (moment(dataRealizacao).isBefore(new Date())) {
                            // Se a data do atendimento já tiver passado, não pode cancelar, a não ser que o usuário seja administrador
                            return false;
                        }
                    }
                    return true;
                case SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE:
                case SITUACAO_SOLICITACAO.EM_REGULACAO:
                    return true;
            }
            return false;
        },
        confirmarSolicitacao() {
            this.showModalConfirmarCancelar = true;
            this.cancelar = false;
            this.confirmar = true;
            this.adicionarInformacao = false;
        },
        cancelarSolicitacao() {
            this.showModalConfirmarCancelar = true;
            this.cancelar = true;
            this.confirmar = false;
            this.adicionarInformacao = false;
        },
        addInformacao() {
            this.showModalConfirmarCancelar = true;
            this.cancelar = false;
            this.confirmar = false;
            this.adicionarInformacao = true;
        },
        solicitacaoCancelada(solicitacao) {
            this.$swal({
                type: "success",
                title: "Solicitação cancelada com sucesso!",
                showConfirmButton: false,
                timer: 1500
            });
            this.atualizar(solicitacao);
        },
        solicitacaoConfirmada(solicitacao) {
            this.$swal({
                type: "success",
                title: "Solicitação confirmada com sucesso!",
                showConfirmButton: false,
                timer: 1500
            });
            this.atualizar(solicitacao);
        },
        informacaoAdicionada(solicitacao) {
            this.$swal({
                type: "success",
                title: "Informações enviadas com sucesso!",
                showConfirmButton: false,
                timer: 1500
            });
            this.atualizar(solicitacao);
        },
        atualizar(solicitacao) {
            this.showModalConfirmarCancelar = false;
            this.$props.solicitacao.situacao = solicitacao.situacao;
            this.$props.solicitacao.solicitacao_historicos = solicitacao.solicitacao_historicos;
        }
    },
    watch: {},
    components: {
        modalConfirmarCancelar,
        solicitacaoDetalhes,
        solicitacaoHistorico,
        solicitacaoBoleto
    }
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

.modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
}

.modal-container {
    width: 70%;
    margin: 40px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #333;
}

.modal-body {
    margin: 10px 0;
}

.text-right {
    text-align: right;
}

.form-label {
    display: block;
    margin-bottom: 1em;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
																						 * The following styles are auto-applied to elements with
																						 * transition="modal" when their visibility is toggled
																						 * by Vue.js.
																						 *
																						 * You can easily play with the modal transition by editing
																						 * these styles.
																						 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal {
    display: block !important;
    /* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
    overflow-y: initial !important;
}

.modal-body {
    height: 350px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// modalDetalhesSolicitacao.vue?c1bd0bc2